module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("LITTLE MISS MOUSE")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "t"
  }, [_vm._v("\nBY"), _c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "t1"
  }, [_vm._v("AMY E. BLANCHARD"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "t"
  }, [_vm._v("\nAuthor of \"Little Maid Marian,\" \"Little Miss Oddity,\""), _c('br', {
    staticClass: "calibre4"
  }), _vm._v("\n\"Little Sister Anne,\" \"Mistress May,\" etc."), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8097cf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section00_0001.vue
// module id = 60
// module chunks = 0